import { create } from "zustand";
import type { ScheduleDocument } from "../lib/schedule-document/schedule-json";
import { parseScheduleDocument } from "../lib/schedule-document/schedule-json";

export type ReferenceSchedule = {
  id: string;
  name: string;
  color: string;
  visible: boolean;
  document: ScheduleDocument;
};

const referenceColors = ["#0d9488", "#d97706", "#2563eb", "#db2777", "#65a30d", "#0891b2"];

type ReferenceScheduleState = {
  references: ReferenceSchedule[];
  nextNumber: number;
  add: (name: string, text: string) => void;
  rename: (id: string, name: string) => void;
  toggle: (id: string) => void;
  remove: (id: string) => void;
};

export const useReferenceScheduleStore = create<ReferenceScheduleState>((set) => ({
  references: [],
  nextNumber: 1,
  add: (name, text) => {
    const document = parseScheduleDocument(text); // Throws on bad JSON before touching state
    set((state) => {
      const color = referenceColors[(state.nextNumber - 1) % referenceColors.length]!;
      const reference = { id: `ref-${state.nextNumber}`, name, color, visible: true, document };
      return { references: [...state.references, reference], nextNumber: state.nextNumber + 1 };
    });
  },
  rename: (id, name) =>
    set((state) => ({ references: state.references.map((item) => (item.id === id ? { ...item, name } : item)) })),
  toggle: (id) =>
    set((state) => ({
      references: state.references.map((item) => (item.id === id ? { ...item, visible: !item.visible } : item)),
    })),
  remove: (id) => set((state) => ({ references: state.references.filter((item) => item.id !== id) })),
}));
